<template>
  <div id="questionSubmitView">
    <h2 class="bo">浏览历史提交</h2>
    <a-form :model="form" layout="inline" class="bo">
      <a-form-item label="题号">
        <a-input
          v-model="form.questionId"
          placeholder="请输入题号"
          style="min-width: 240px"
        />
      </a-form-item>
      <a-form-item label="编程语言">
        <a-select
          style="width: 160px; margin-bottom: 7px"
          :trigger-props="{ autoFitPopupMinWidth: true }"
          v-model="form.language"
        >
          <a-option>java</a-option>
          <a-option>cpp</a-option>
          <a-option>python</a-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button @click="doSearch" type="primary">搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table
      :columns="columns"
      :data="dataList"
      :pagination="{
        showTotal: true,
        pageSize: searchParams.pageSize,
        current: searchParams.current,
        total: total,
        showPageSize: true,
        showJumper: true,
      }"
      @page-change="changePageNum"
      @page-size-change="changePageSize"
    >
      <template #judgeInfo="{ record }">
        <a-space>
          <table>
            <tbody>
              <tr v-for="(value, key) in record.judgeInfo" :key="key">
                <td style="font-weight: bolder">{{ key }}:</td>
                <td>{{ value }}</td>
              </tr>
            </tbody>
          </table>
        </a-space>
      </template>
      <template #message="{ record }">
        <a-space>
          <span v-if="record?.judgeInfo?.message == 'Accepted'">
            <a-tag color="green">
              {{ record?.judgeInfo?.message }}
            </a-tag>
          </span>
          <span v-else-if="record?.judgeInfo?.message == null">
            <a-tag color="orange">Waiting</a-tag>
          </span>
          <span v-else>
            <a-tag color="red">
              {{ record?.judgeInfo?.message }}
            </a-tag>
          </span>
        </a-space>
      </template>
      <template #time="{ record }">
        <a-space> {{ record?.judgeInfo?.time }} ms</a-space>
      </template>
      <template #memory="{ record }">
        <a-space>
          {{ (record?.judgeInfo?.memory / 1024).toFixed(2) }} MB
        </a-space>
      </template>
      <template #status="{ record }">
        <a-space>
          {{ statusFormat(record.status) }}
        </a-space>
      </template>
      <template #createTime="{ record }">
        <a-space>
          {{ timeFormat(record.createTime) }}
        </a-space>
      </template>
    </a-table>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref, watchEffect } from "vue";
import message from "@arco-design/web-vue/es/message";
import { MyAxios } from "@/plugins/axios";
import { useRouter } from "vue-router";
import moment from "moment-timezone/moment-timezone-utils";
import { useStore } from "vuex";

const router = useRouter();
const store = useStore();
// console.log(store.state.user.loginUser.id);

const dataList = ref([]);
const total = ref(0);
const searchParams = ref({
  userId: store.state.user.loginUser.id,
  current: 1,
  pageSize: 10,
  language: "",
  questionId: "",
  status: "",
});
const form = ref({
  ...searchParams.value,
});

/**
 * 加载数据
 */
const loadData = async () => {
  await MyAxios.post(
    "/question/question_submit/list/page",
    searchParams.value
  ).then((res) => {
    if (res.data.code === 0) {
      dataList.value = res.data.data.records;
      total.value = res.data.data.total;
      // console.log(res.data.data.records);
    } else {
      message.error("加载失败：" + res.data.message);
    }
  });
};

const statusFormat = (status: number) => {
  if (status == 0) {
    return "待判题";
  }
  if (status == 1) {
    return "判题中";
  }
  if (status == 2) {
    return "已完成";
  }
  if (status == 3) {
    return "判题失败";
  }
};
const timeFormat = (time: any) => {
  return moment(time).tz("Asia/Shanghai").format("YYYY-MM-DD hh:mm");
};
let interval: any;
onMounted(() => {
  loadData();
  interval = setInterval(loadData, 15000); // 每10秒加载一次新数据
});
onUnmounted(() => {
  clearInterval(interval); // 清除定时器以防内存泄漏
});
watchEffect(() => {
  loadData();
});

const changePageNum = (current: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: current,
  };
};
const changePageSize = (pageSize: number) => {
  searchParams.value = {
    ...searchParams.value,
    pageSize: pageSize,
  };
};
const doSearch = () => {
  searchParams.value = {
    ...searchParams.value,
    questionId: form.value.questionId,
    language: form.value.language,
    current: 1,
  };
};

const columns = [
  {
    title: "题号",
    dataIndex: "questionId",
  },
  {
    title: "编程语言",
    dataIndex: "language",
  },
  {
    title: "状态",
    slotName: "status",
  },
  {
    title: "结果",
    slotName: "message",
  },
  {
    title: "消耗时间",
    slotName: "time",
  },
  {
    title: "消耗内存",
    slotName: "memory",
  },
  {
    title: "创建时间",
    slotName: "createTime",
  },
];
</script>

<style scoped>
#questionSubmitView {
  max-width: 1280px;
  margin: 0 auto;
}

.bo {
  margin-bottom: 12px;
}
</style>
